{
  "id": "monia",
  "name": "Mónia",
  "description": "Neon pink theme (for Mónia) — hot magenta on a blush/near-black base",
  "colors": {
    "light": {
      "primary": "#ff1493",
      "secondary": "#ffd1e8",
      "positive": "#16a34a",
      "negative": "#dc2626",
      "warning": "#d97706",
      "important": "#ff007f",
      "light": "#fff0f7",
      "dark": "#1a0512",
      "surface": "#ffffff",
      "darksurface": "#2a0a1d",
      "white": "#ffffff"
    },
    "dark": {
      "primary": "#ff2d95",
      "secondary": "#3d1029",
      "positive": "#4ade80",
      "negative": "#fb7185",
      "warning": "#fbbf24",
      "important": "#ff4fd8",
      "light": "#ffe6f3",
      "dark": "#12040c",
      "surface": "#ffe6f3",
      "darksurface": "#22081a",
      "white": "#ffffff"
    }
  }
}
